(function ($) {
  "use strict";
  $(function () {
    if ($(".js-pm-review-slider").length) {
      // A .pm-review-slider__slide 32-32px paddingot kap oldalt (hogy a kártya
      // árnyékának legyen hova kifutnia a swiper vágási élén belül), ez
      // slide-onként 64px-et hozzáad a látható réshez a kártyák között, ezért
      // itt ugyanennyivel csökkentjük a spaceBetween-t, hogy a rés a kártyák
      // között a kívánt méretű maradjon.
      let pmReviewSwiper = new Swiper(".js-pm-review-slider", {
        slidesPerView: 1,
        speed: 400,
        spaceBetween: 16 - 64,
        watchSlidesProgress: true,
        grabCursor: true,
        mousewheel: {
          forceToAxis: true,
        },
        pagination: {
          el: ".js-pm-review-slider-pagination",
          clickable: true,
        },
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 32 - 64,
          },
        },
      });
    }
  });
})(jQuery);
